import { Component, inject, OnInit } from '@angular/core';
import { DateFilterComponent } from '../../_shared/components/filters/date-filter/date-filter.component';
import { AccountFilterData, DateIntervalFilterData, WidgetFilterData } from '../../_shared/models';
import { OvertimeDriverListComponent } from './components/overtime-driver-list/overtime-driver-list.component';
import { OvertimeDriverDetailsComponent } from './components/overtime-driver-details/overtime-driver-details.component';
import { FilterService } from '../../_shared/services';
import { OvertimeActivitySummaryComponent } from './components/overtime-activity-summary/overtime-activity-summary.component';
import { DriverOvertimeActivitySummary } from './models/driver-activity-summary.model';
import { OvertimeHoursSummary } from './models/overtime-hours-summary.model';
import { OvertimeHoursSummaryComponent } from './components/overtime-hours-summary/overtime-hours-summary.component';
import { isEmptyObject } from '../../_shared/helpers/helpers';
import { CommonModule } from '@angular/common';
import { OvertimeManagementListService } from './services/overtime-management-list.service';
import { AccountFilterComponent } from "../../_shared/components/filters/account-filter/account-filter.component";
import { SearchComponent } from "../../_shared/components/filters/search/search.component";
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-overtime-management',
  standalone: true,
  imports: [
    DateFilterComponent,
    OvertimeDriverListComponent,
    OvertimeDriverDetailsComponent,
    OvertimeActivitySummaryComponent,
    OvertimeHoursSummaryComponent,
    CommonModule,
    AccountFilterComponent,
    SearchComponent,
    TranslocoDirective,
    TranslocoPipe
  ],
  templateUrl: './overtime-management.component.html',
  styleUrl: './overtime-management.component.scss',
})
export class OvertimeManagementComponent implements OnInit {
  private filterService = inject(FilterService);
  private overtimeManagementListService = inject(OvertimeManagementListService);

  public dateFilter: DateIntervalFilterData;
  public showOnlyRequiresDecision: boolean = false;
  public activityWidgetLoading: boolean = false;
  public overtimeActivitySummary: DriverOvertimeActivitySummary;
  public overtimeHoursSummary: OvertimeHoursSummary;
  public accountFilter: AccountFilterData;
  public hasOvertime: boolean = true;
  public listLoaded: boolean = false;
  public detailsLoaded: boolean = false;
  public isSearchDisabled: boolean = false;
  public isSearching: boolean = false;

  ngOnInit(): void {
    this.accountFilter = {} as AccountFilterData;
    this.dateFilter = {} as DateIntervalFilterData;
    this.subscribeToDriverOvertimes();
  }

  onAccountFilterChange(filter: AccountFilterData): void {
    this.accountFilter = filter;
    this.updateFilter();
  }

  onDateFilterChange(filter: DateIntervalFilterData): void {
    this.dateFilter = filter;
    this.updateFilter();
  }

  updateFilter(): void {
    if (!isEmptyObject(this.accountFilter) && !isEmptyObject(this.dateFilter)) {
      this.filterService.updateFilter({
        ...this.accountFilter,
        ...this.dateFilter
      } as WidgetFilterData);
    }
  }

  subscribeToDriverOvertimes() {
    this.overtimeManagementListService.driverOvertimes$.subscribe((driverOvertimes) => {
      this.hasOvertime = Array.isArray(driverOvertimes) && driverOvertimes.length > 0;
      this.listLoaded = true;
      this.detailsLoaded = true;
    });
  }

  onSearchTermUpdate(searchTerm: string): void {
    this.filterService.updateSearchTerm(searchTerm || '');
    this.isSearching = searchTerm.trim().length > 0;
    this.listLoaded = false;
    this.detailsLoaded = false;
  }

  public toggleDecisionFilter(event: Event) {
    this.showOnlyRequiresDecision = (event.target as HTMLInputElement).checked;
    this.listLoaded = false;
    this.detailsLoaded = false;
  }
}